import { computed, ref, type ComputedRef } from 'vue';

// A counter rather than a flag: two saves in a row each have to land, and the sheet may already be open.
const expandRequests = ref<number>(0);

type AiSheetExpansion = {
    expandRequests: ComputedRef<number>;
    requestSheetExpansion: () => void;
};

export function useAiSheetExpansion(): AiSheetExpansion {
    function requestSheetExpansion(): void {
        expandRequests.value += 1;
    }

    return { expandRequests: computed<number>(() => expandRequests.value), requestSheetExpansion };
}

/** Exposed for tests. */
export function resetAiSheetExpansionState(): void {
    expandRequests.value = 0;
}
